import {idGenerator} from "_src/utils";
import {colorType, objectType} from "_src/constants";
import appState from "_src/app_state";
import config from "_src/config";

export default class DetachedWrapper {
  constructor(params) {
    this.id = idGenerator.getNext();
    this.type = objectType.FUSION;
    this.model = params.model !== undefined ? params.model : null;
    this.frames = [];

    this._visibility = false;
  }

  getID() {
    return this.id;
  }

  getVisibility() {
    return this._visibility;
  }

  setVisibility(visibility) {
    this._visibility = visibility;
    for (const frame of this.frames) {
      frame.setVisibility(visibility);
    }
  }

  getWorldMinmax() {
    return this.model.minmaxWorld;
  }

  updateTextureUsage(textureRequested = appState.getStateValue("colorMode") === appState.CM_TEXTURE) {
    if (this.frames.length < 1) return;
    let hasTextures = this.frames[0].textureList.length > 0;

    const textureUsed = textureRequested && hasTextures;
    const colorMode = textureUsed ? colorType.TEXTURE_UV : colorType.UNIFORM;
    const reflectivity = textureUsed ? config.textureReflectivity : config.diffuseReflectivity;
    this.model.setColorMode(colorMode);
    this.frames[0].model.setReflectivity(reflectivity);
    this.frames[0].model.properties.enableLambertDiffuse = textureUsed;
    this.frames[0].model.properties.enableColorCorrection = textureUsed;
 }
}
